import { INVOICE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/invoice_download_formats_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['invoiceFormatsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
